import React, { useContext, useEffect, useState } from "react";
import { Nav, ProgressBar } from "react-bootstrap";
import _ from "lodash";
import { UserContext, Utils } from "../../common";

const hasAnyPath = (pathary) => {
  return _.filter(pathary,(path)=> window.location.pathname.indexOf(path) > -1).length > 0
};

const activeClass = (bool) => {
  return bool ? "py-2 active" : "py-2";
}

const isActive = (pathary) => {
  return activeClass(hasAnyPath(pathary));
};

const varmenu = {
  'dashboard': ['dashboard'],
  'timehub': ["attendance","myrota","leave"],
  'workflow': ["jobs","todo"],
  'training': ["cpd","resources","help-materials"],
  'performance': ["reports","evidences"],
  'adminc': ["comrota","users","cqc","userdocument","myprofile"]
};

const pageLoadedMenu = () => {
  var val = '';
  _.each(varmenu, (ary,key) => {
    if(hasAnyPath(ary)) val = key;
  })
  return val;
};

const imageState = (nm) => {
  var src = process.env.PUBLIC_URL + "/images/" + nm;
  
  if(!hasAnyPath(varmenu[nm])){
    src += "-d";
  }
  src += ".png";
  return <img src={src} style={{ marginRight: "18px !important" }} width="19" alt={nm} />;
};

const Sidebar = () => {
  const { userData, goTraining, hasAccess } = useContext(UserContext);
  const [training, setTraining] = useState(false);

  const [openMenu, setOpenMenu] = useState(pageLoadedMenu());

  const handleGoTraining = (e) => {
    setTraining(true);
    goTraining()
      .then(() => setTraining(false))
      .catch(() => setTraining(false));
  };

  return (
    <React.Fragment>
      <Nav className=" bg-light sidebar pt-3">
        {(userData.is_super_user || Utils.hasAccess(1)) && (
          <Nav.Link className={isActive(["dashboard"])} href={`${process.env.PUBLIC_URL}/dashboard`}>
            {imageState("dashboard")} Dashboard
          </Nav.Link>
        )}


        {(userData.is_super_user || Utils.hasAccess(2) || Utils.hasAccess(5)) && (<>
          <div className={`nav-link ${isActive(["attendance","myrota","leave"])} ${activeClass(openMenu==='timehub')}`}>
            <div onClick={() => setOpenMenu(openMenu==='timehub' ? '' : 'timehub')}>
            {imageState("timehub")} Time Hub <img className="mt-2 float-end" src={`${process.env.PUBLIC_URL}/images/menu-${openMenu==='timehub'?'opened':'closed'}.png`} /></div>

            <div className={`submenu ${(openMenu==='timehub') ? 'd-block' : 'd-none'}`}>
              {(userData.is_super_user || Utils.hasAccess(2)) && (
                <a className={isActive(["attendance"])} href={`${process.env.PUBLIC_URL}/attendance`}>
                  Attendance
                </a>
              )}
              {(userData.is_super_user || Utils.hasAccess(2)) && (
                <a className={isActive(["myrota"])} href={`${process.env.PUBLIC_URL}/myrota`}>
                  My Rota
                </a>
              )}
              {(userData.is_super_user || Utils.hasAccess(5)) && (
                <a className={isActive(["leave"])} href={`${process.env.PUBLIC_URL}/leave`}>
                  Holiday
                </a>
              )}
            </div>
          </div>
          
        </>)}

        {(userData.is_super_user || Utils.hasAccess(3) || Utils.hasAccess(4)) && (<>
          <div className={`nav-link ${isActive(["jobs","todo"])} ${activeClass(openMenu==='workflow')}`}>
            <div onClick={() => setOpenMenu(openMenu==='workflow' ? '' : 'workflow')}>
            {imageState("workflow")} Workflow <img className="mt-2 float-end" src={`${process.env.PUBLIC_URL}/images/menu-${openMenu==='workflow'?'opened':'closed'}.png`} /></div>

            <div className={`submenu ${(openMenu==='workflow') ? 'd-block' : 'd-none'}`}>
              {(userData.is_super_user || Utils.hasAccess(3)) && (
                <a className={isActive(["jobs"])} href={`${process.env.PUBLIC_URL}/jobs`}>
                  Jobs
                </a>
              )}
              {(userData.is_super_user || Utils.hasAccess(4)) && (
                <a className={isActive(["todo"])} href={`${process.env.PUBLIC_URL}/todo`}>
                  Tasks
                </a>
              )}
            </div>
          </div>
          
        </>)}

        {(userData.is_super_user || Utils.hasAccess(6) || Utils.hasAccess(8) || Utils.hasAccess(9)) && (<>
          <div className={`nav-link ${isActive(["resources","help-materials"])} ${activeClass(openMenu==='training')}`}>
            <div onClick={() => setOpenMenu(openMenu==='training' ? '' : 'training')}>
            {imageState("training")} Training <img className="mt-2 float-end" src={`${process.env.PUBLIC_URL}/images/menu-${openMenu==='training'?'opened':'closed'}.png`} /></div>

            <div className={`submenu ${(openMenu==='training') ? 'd-block' : 'd-none'}`}>
              {!training && (userData.is_super_user || Utils.hasAccess(9)) && (
                <Nav.Link onClick={handleGoTraining}>CPD</Nav.Link>
              )}
              {(userData.is_super_user || Utils.hasAccess(6)) && (
                <a className={isActive(["resources"])} href={`${process.env.PUBLIC_URL}/resources`}>
                  Resources
                </a>
              )}
              {(userData.is_super_user || Utils.hasAccess(8)) && (
                <a className={isActive(["help-materials"])} href={`${process.env.PUBLIC_URL}/help-materials`}>
                  Help Materials
                </a>
              )}
            </div>
          </div>
          
        </>)}

        {(userData.is_super_user || Utils.hasAccess(7) || userData.manager) && (<>
          <div className={`nav-link ${isActive(["reports","evidences"])} ${activeClass(openMenu==='performance')}`}>
            <div onClick={() => setOpenMenu(openMenu==='performance' ? '' : 'performance')}>
            {imageState("performance")} Performance <img className="mt-2 float-end" src={`${process.env.PUBLIC_URL}/images/menu-${openMenu==='performance'?'opened':'closed'}.png`} /></div>

            <div className={`submenu ${(openMenu==='performance') ? 'd-block' : 'd-none'}`}>
              {userData.manager && (
                <a className={isActive(["reports"])} href={`${process.env.PUBLIC_URL}/reports`}>
                  Reports
                </a>
              )}
              {(userData.is_super_user || Utils.hasAccess(7)) && (
                <a className={isActive(["evidences"])} href={`${process.env.PUBLIC_URL}/evidences`}>
                  Evidence
                </a>
              )}
            </div>
          </div>
          
        </>)}


        {(Utils.hasAccess(10) || userData.is_super_user || userData.is_rota || userData.is_cqc) && (<>
          <div className={`nav-link ${isActive(["users","comrota","myprofile","cqc"])} ${activeClass(openMenu==='adminc')}`}>
            <div onClick={() => setOpenMenu(openMenu==='adminc' ? '' : 'adminc')}>
            {imageState("adminc")} Compliance <img className="mt-2 float-end" src={`${process.env.PUBLIC_URL}/images/menu-${openMenu==='adminc'?'opened':'closed'}.png`} /></div>

            <div className={`submenu ${(openMenu==='adminc') ? 'd-block' : 'd-none'}`}>
              {userData.is_rota && (
                <a className={isActive(["comrota"])} href={`${process.env.PUBLIC_URL}/comrota`}>
                    Rota
                </a>
              )}
              {userData.is_super_user && (
                <a className={isActive(["users"])} href={`${process.env.PUBLIC_URL}/users`}>
                  Users
                </a>
              )}
              
              {userData.is_cqc && <a className={isActive(["cqc"])} href={`${process.env.PUBLIC_URL}/cqc`}>CQC</a>}              
              {userData.is_super_user &&  <a className={isActive(["userdocument"])} href={`${process.env.PUBLIC_URL}/userdocument`}>HR</a>}
              
              {(userData.is_super_user || Utils.hasAccess(10)) && (
                <a className={isActive(["myprofile"])} href={`${process.env.PUBLIC_URL}/myprofile`}>
                  My Profile
                </a>
              )}
            </div>
          </div>
          
        </>)}
       
          
        {training && (userData.is_super_user || Utils.hasAccess(9)) && <ProgressBar variant="info" animated now={100} className="mx-5" />}
        <div className="d-block text-center poweredBy mt-5">
          <img src={`${process.env.PUBLIC_URL}/images/poweredBy.png`} width="124" height="42" className="" alt={process.env.REACT_APP_POWEREDBY} />{" "}
        </div>
      </Nav>
    </React.Fragment>
  );
};
export default Sidebar;
